(function () {
  var selector = 'img[width="1"][height="1"]:not([alt])';

  function markDecorative(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) node.setAttribute('alt', '');
    node.querySelectorAll(selector).forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  markDecorative(document.documentElement);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(markDecorative);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
